import { HeaderMenu } from '../types/header-menu.type';

/** Solutions submenu items (used in header dropdown and hero CTAs) */
export const solutionsSubmenuData: HeaderMenu[] = [
  { name: 'header.forInstallers', link: '/solutions/installers' },
  { name: 'header.forDevelopersOwners', link: '/solutions/developers' },
  { name: 'header.forArchitectsDesigners', link: '/solutions/architects' },
  { name: 'header.forSuppliers', link: '/solutions/suppliers' },
];

/** Marketplace submenu items (products, auctions, tenders) */
export const marketplaceSubmenuData: HeaderMenu[] = [
  { name: 'header.products', link: '/products' },
  { name: 'header.projects', link: '/projects' },
  { name: 'header.auctions', link: '/auctions' },
  { name: 'header.tenders', link: '/tenders' },
];

export const mainHeaderMenuData: HeaderMenu[] = [
  {
    name: 'header.home',
    icon: 'home-2',
    link: '/',
    exact: true,
  },
  {
    name: 'header.marketplace',
    icon: 'box',
    link: '/products',
    children: marketplaceSubmenuData,
  },
  {
    name: 'header.solutionHowItWorks',
    icon: 'setting-2',
    link: '/solutions',
    children: solutionsSubmenuData,
  },
  {
    name: 'header.about',
    icon: 'info-circle',
    link: '/about',
  },
  {
    name: 'header.team',
    icon: 'users',
    link: '/team',
  },
  {
    name: 'header.contact',
    icon: 'phone-ringing',
    link: '/contact',
  },
];

/** @deprecated Use solutionsSubmenuData for hero CTAs. Kept for backward compatibility. */
export const secondaryHeaderMenuData: HeaderMenu[] = solutionsSubmenuData;

// Combined for backward compatibility
export const headerMenuData: HeaderMenu[] = [
  ...mainHeaderMenuData,
  ...secondaryHeaderMenuData,
];
